import * as Common from '../../commons/common';
export { SheetGroup, Student, Condition, Sheet } from "../../modules/teacher/ClassroomSheetEdit";
import { SheetBase as ClassroomSheetBase } from "../../modules/teacher/ClassroomSheetEdit";

export class SheetBase extends ClassroomSheetBase {
  api_type: number = Common.ApiTypeEnum.Teams
}
